import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Smartphone } from "lucide-react";

import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
import { getAppDownloadUrl } from "../../config/mobileApp";

import logoImg from "../../assets/images/logo/fincompay-logo.png";
import classes from "./FincompayApp.module.scss";

const FincompayApp: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("fincompayApp.pageTitle");
  }, [t]);

  return (
    <div className={classes.page}>
      <div className={classes.glow} aria-hidden />
      <div className={classes.glow2} aria-hidden />

      <main className={classes.card}>
        <header className={classes.header}>
          <img
            src={logoImg}
            alt="FinComPay"
            className={classes.logo}
            width={140}
            height={32}
          />
          <LanguageSwitcher />
        </header>

        <span className={classes.badge}>{t("fincompayApp.badge")}</span>
        <h1 className={classes.title}>{t("fincompayApp.title")}</h1>
        <p className={classes.subtitle}>{t("fincompayApp.subtitle")}</p>

        <div className={classes.actions}>
          <a
            className={classes.primaryBtn}
            href={getAppDownloadUrl()}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Smartphone size={20} aria-hidden />
            {t("fincompayApp.openApp")}
          </a>
        </div>

        <p className={classes.support}>
          {t("fincompayApp.support")}{" "}
          <a href="tel:+37322269999">022 269 999</a>
        </p>
      </main>
    </div>
  );
};

export default FincompayApp;
